export default {
  path: '/design_system',
  name: 'design_system',
  component: () => import('../views/design_system/DesignSystem.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'design_system',
      linkText: 'Дизайн система'
    }
  }
}